// extracted by mini-css-extract-plugin
export var aircallIframe = "_cj-3";
export var fabContainer = "_cj-5";
export var fabRinging = "_cj-6";
export var loadingOverlay = "_cj-4";
export var pulse = "_cj-7";
export var widgetContent = "_cj-2";
export var widgetPanel = "_cj-0";
export var widgetPanelExpanded = "_cj-1";